// Small stateless helpers used by HomeBookingWidget. Extracted so the
// main widget file doesn't own trivial factories + a fallback price
// formatter.

// Legacy EUR formatter — retained as a fallback for any non-context
// caller. UI components inside the widget use the currency-aware
// `formatEstimate` from CurrencyContext, which honours the global
// selector.
export const fmtEUR = (amount, lang) => {
  const localeMap = { en: "en-GB", fr: "fr-FR", es: "es-ES" };
  try {
    return new Intl.NumberFormat(localeMap[lang] || "en-GB", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `€${Math.round(amount).toLocaleString()}`;
  }
};

// Factory for a fresh "room" row inside a property block. First room
// keeps 2 adults by default; extra rooms also default to 2 adults so
// the UX matches how families typically book.
export const newRoom = (idx = 0) => ({
  id: `r-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
  room_type: "",
  adults: idx === 0 ? 2 : 2,
  children: 0,
  infants: 0,
  board_basis: "breakfast",
});

// Factory for a fresh property-block. Each block represents one row in
// the widget (one hotel / bivouac / camp with its own dates + rooms).
// `rowId` allows the same property to appear more than once via the
// "duplicate" action.
// `campSlug` is only meaningful for hotels that host more than one
// bookable camp under the same parent slug (currently just La Belle
// Étoile Bivouacs). It's a SINGLE camp slug — each selected camp
// becomes its own independent block so guests can configure dates,
// rooms and notes per camp. `campSlugs` is kept as a derived
// backward-compat array (`[campSlug]`) so existing display components
// (PropertyBlock header) keep working without changes.
export const newBlock = (slug, campSlug = null) => {
  const camp = typeof campSlug === "string" && campSlug ? campSlug : null;
  return {
    rowId: `${slug}${camp ? `__${camp}` : ""}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
    slug,
    campSlug: camp,
    campSlugs: camp ? [camp] : [],
    check_in: "",
    check_out: "",
    notes: "",
    rooms: [newRoom(0)],
  };
};
